export const getStorageItem = <T>(key: string, storage: 'session' | 'local', jsonParse?: boolean): T | null => {
  try {
    let item = storage === 'session' ? sessionStorage.getItem(key) : localStorage.getItem(key);
    if (item) {
      if (jsonParse) item = JSON.parse(item);
      return item as unknown as T;
    }
    return null;
  } catch (error) {
    console.error('Error while JSON parsing storage item');
    console.error(error);
    return null;
  }
};

export const getStorageItems = (keys: string[], storage: 'session' | 'local', jsonParse: boolean[]): unknown[] => {
  try {
    return keys.map((key, i) => {
      let item = storage === 'session' ? sessionStorage.getItem(key) : localStorage.getItem(key);
      if (item) {
        if (jsonParse[i]) item = JSON.parse(item);
        return item;
      }
      return null;
    });
  } catch (error) {
    console.error('Error while JSON parsing storage items');
    console.error(error);
    return [];
  }
};

export const setStorageItems = (keys: string[], items: unknown[], storage: 'session' | 'local'): boolean => {
  try {
    items.forEach((item, i) => {
      const itemToSave = typeof item === 'object' ? JSON.stringify(item) : `${item}`;
      storage === 'session' ? sessionStorage.setItem(keys[i], itemToSave) : localStorage.setItem(keys[i], itemToSave);
    });
    return true;
  } catch (error) {
    console.error('Error while setting item to browser storage');
    console.error(error);
    return false;
  }
};

export const removeStorageItems = (keys: string[], storage: 'session' | 'local' | 'both'): boolean => {
  try {
    for (const key of keys) {
      switch (storage) {
        case 'session':
          sessionStorage.removeItem(key);
          break;
        case 'local':
          localStorage.removeItem(key);
          break;
        case 'both':
          sessionStorage.removeItem(key);
          localStorage.removeItem(key);
          break;
      }
    }
    return true;
  } catch (error) {
    console.error('Error while removing items from browser storage');
    console.error(error);
    return false;
  }
};
